import { createContext, useContext, useEffect, useState } from "react";

const DiagnosticContext = createContext(null);
const STORAGE_KEY = "twf_diagnostic_session_v1";

const emptySession = {
  pathway: null,
  about: null,
  respondentId: null,
  questions: [],
  answers: {}, // { [index]: optionIndex }
  current: 0, // most recently active question index (persisted mid-diagnostic)
};

export function DiagnosticProvider({ children }) {
  const [session, setSession] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : emptySession;
    } catch {
      return emptySession;
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  }, [session]);

  const update = (patch) => setSession((s) => ({ ...s, ...patch }));
  const setAnswer = (index, optionIndex) =>
    setSession((s) => ({ ...s, answers: { ...s.answers, [index]: optionIndex } }));
  const setCurrent = (index) => setSession((s) => ({ ...s, current: index }));
  const reset = () => setSession(emptySession);

  return (
    <DiagnosticContext.Provider value={{ session, update, setAnswer, setCurrent, reset }}>
      {children}
    </DiagnosticContext.Provider>
  );
}

export const useDiagnostic = () => {
  const ctx = useContext(DiagnosticContext);
  if (!ctx) throw new Error("useDiagnostic must be used within DiagnosticProvider");
  return ctx;
};
